import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 112 112",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M60 94a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm41.51-4.33a4.56 4.56 0 0 0 .3 1.98L64.5 97.33a4.56 4.56 0 0 0-.3-1.98l37.32-5.68zM106 87a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM54.76 62.14l5.45 30.36H60c-.62 0-1.22.13-1.76.36L52.79 62.5H53c.62 0 1.22-.13 1.76-.36zm39.93-47.97 11.6 71.34a4.57 4.57 0 0 0-1.98.32L92.7 14.49a4.57 4.57 0 0 0 1.98-.32zM12 62a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm36.5-4.25a4.57 4.57 0 0 0 .34 1.97L16.5 65.25a4.57 4.57 0 0 0-.33-1.98l32.35-5.52zM53 55a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM6.74 29.15l5.49 31.36a4.57 4.57 0 0 0-1.97.34L4.77 29.49l.23.01c.62 0 1.2-.12 1.74-.35zM5 22a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM88.5 9.75a4.57 4.57 0 0 0 .34 1.97L9.5 25.25a4.57 4.57 0 0 0-.33-1.97L88.5 9.75zM93 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m92.72 14.5 11.59 71.33a4.5 4.5 0 0 0-2.8 3.84L64.2 95.35a4.5 4.5 0 0 0-3.98-2.85l-5.45-30.36a4.5 4.5 0 1 0-6.25-4.39l-32.35 5.52a4.5 4.5 0 0 0-3.93-2.76l-5.5-31.36a4.5 4.5 0 0 0 2.75-3.9l79.35-13.53a4.5 4.5 0 0 0 3.88 2.77z",
  "fill-opacity": ".45"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }